import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ListController from "./list_controller"
application.register("list", ListController)
